<div class="container">
  <div class="flex flex-column align-items-center justify-content-center">
    <h3 class="text-center">
      Domande frequenti sui viaggi di gruppo con
      <span class="green">Socialtravels</span>
      <img src="/assets/media/icons/logo-st-green.jpg" width="30" />
    </h3>
  </div>
  <div class="mt-6">
    <p-accordion [multiple]="true">
      <p-accordionTab
        header="Come funzionano i viaggi di gruppo organizzati da Socialtravels?"
      >
        <p>
          I viaggi di gruppo di Socialtravels sono pensati per farti vivere
          esperienze autentiche in compagnia di altri viaggiatori come te. Puoi
          scegliere tra decine di destinazioni e unirti a gruppi già formati
          oppure creare il tuo viaggio e partire con la tua community.
        </p>
      </p-accordionTab>

      <p-accordionTab
        header="Devo viaggiare con qualcuno o posso partire anche da solo?"
      >
        <p>
          Assolutamente sì, puoi partire anche da solo! I viaggi di gruppo di
          Socialtravels sono perfetti per chi vuole conoscere nuove persone e
          vivere un’esperienza condivisa. Spesso, nascono amicizie che
          continuano anche dopo il viaggio.
        </p>
      </p-accordionTab>

      <p-accordionTab header="Chi accompagna i gruppi durante il viaggio?">
        <p>
          Ogni gruppo è guidato da un Tour Leader esperto selezionato da
          Socialtravels. Sono figure competenti, appassionate e sempre presenti
          per garantire sicurezza, organizzazione e divertimento durante tutto
          il viaggio.
        </p>
      </p-accordionTab>

      <p-accordionTab
        header="Quali destinazioni posso scegliere con Socialtravels?"
      >
        <p>
          Socialtravels propone viaggi di gruppo in tutto il mondo: Europa,
          Asia, Americhe, Africa e isole paradisiache. Ogni itinerario è
          costruito per offrire un mix perfetto di scoperta, relax e momenti di
          condivisione.
        </p>
      </p-accordionTab>

      <p-accordionTab
        header="Come posso prenotare un viaggio di gruppo con Socialtravels?"
      >
        <p>
          È semplicissimo! Vai sul sito, consulta i viaggi in partenza o le
          destinazioni disponibili, seleziona quello che ti interessa e prenota
          direttamente online. Riceverai tutte le informazioni via email.
        </p>
      </p-accordionTab>

      <p-accordionTab
        header="Posso proporre io un viaggio e diventare Tour Leader?"
      >
        <p>
          Certo! Con Socialtravels puoi creare il tuo viaggio di gruppo e
          proporlo alla tua community. Se hai spirito d’iniziativa e passione
          per il viaggio, puoi diventare Tour Leader e guidare un gruppo verso
          l’esperienza che hai progettato.
        </p>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
